<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Tarjetas</p>
    <h2 class="">Tarjetas</h2>
  </div>
  <!-- <dx-button text="Agregar tarjetas" icon="plus" type="default" (onClick)="grid.instance.addRow()">
  </dx-button> -->
  <dx-button text="Agregar tarjetas" icon="plus" type="default" (onClick)="newCardForm()">
  </dx-button>
</div>
<div class="dx-card content-block">
  <div class="responsive-paddings">
    <dx-data-grid #grid [dataSource]="cardsList" keyExpr="id" [allowColumnReordering]="true"
      (onRowRemoving)="deleteCard($event)" showBorders="true" class="cardsGrid">
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <dxi-column dataField="cardName" caption="Nombre"></dxi-column>
      <dxi-column dataField="cardProvider" caption="Proveedor" [width]="125">
        <dxo-lookup [dataSource]="cardProviders" displayExpr="name" valueExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="cardBrand" caption="Marca">
        <dxo-lookup [dataSource]="cardBrands" displayExpr="name" valueExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="programName" caption="Programa">
        <dxo-lookup [dataSource]="programsList" displayExpr="name" valueExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="batchNumber" caption="Lote" dataType="string" class="uper-case"></dxi-column>
      <dxi-column dataField="numberOfCards" caption="Cantidad de tarjetas" dataType="number"></dxi-column>
      <dxi-column dataField="serialFrom" caption="Serial del" dataType="string"
        [editorOptions]="{ mask: '0000-0000-0000-0000'}">
      </dxi-column>
      <dxi-column dataField="serialTo" caption="Serial al" dataType="string"
        [editorOptions]="{ mask: '0000-0000-0000-0000'}">
      </dxi-column>
      <dxi-column dataField="tempExpirationDate" caption="Expiración" dataType="date" [visible]="false"></dxi-column>
    </dx-data-grid>
    <dx-popup [showTitle]="true" width="55%" height="600px" title="Nuevo lote de tarjetas" [dragEnabled]="false"
      [closeOnOutsideClick]="true" [(visible)]="popupVisible">
      <div *dxTemplate="let data of 'content'">
        <div class="flex flex-nowrap popup-form">
          <!-- LEFT  -->
          <div class=" responsive-paddings flex-grow-1">
            <div class='dx-field'>
              <div class='dx-field-label'>Nombre</div>
              <div class='dx-field-value'>
                <dx-text-box [(value)]="newCard.cardName">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Marca</div>
              <div class='dx-field-value'>
                <dx-select-box [(value)]="newCard.cardBrand" [dataSource]="cardBrands" displayExpr="name"
                  valueExpr="name">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Lote</div>
              <div class='dx-field-value'>
                <dx-text-box [(value)]="newCard.batchNumber" class="uper-case">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Serial desde</div>
              <div class='dx-field-value'>
                <dx-text-box [(value)]="newCard.serialFrom" (onValueChanged)="checkCard()" mask="####-####-####-####">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Expiración</div>
              <div class='dx-field-value'>
                <dx-date-box displayFormat="shortdate" type="date" [(value)]="newCard.tempExpirationDate">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-date-box>
              </div>
            </div>
          </div>
          <!-- RIGHT  -->
          <div class=" responsive-paddings flex-grow-1">
            <div class='dx-field'>
              <div class='dx-field-label'>Proveedor</div>
              <div class='dx-field-value'>
                <dx-select-box [(value)]="newCard.cardProvider" [dataSource]="cardProviders" displayExpr="name"
                  valueExpr="name">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Programa</div>
              <div class='dx-field-value'>
                <dx-select-box [(value)]="newCard.programName" [dataSource]="programsList" displayExpr="name"
                  valueExpr="name">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Cantidad de tarjetas</div>
              <div class='dx-field-value'>
                <dx-number-box [(value)]="newCard.numberOfCards" (onValueChanged)="checkCard()" [min]="1">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-number-box>
              </div>
            </div>
            <div class='dx-field'>
              <div class='dx-field-label'>Serial al</div>
              <div class='dx-field-value'>
                <dx-text-box [(value)]="newCard.serialTo" [disabled]="true" mask="####-####-####-####">
                  <dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field pt-3">
              <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="addNewCard($event)"
                text="Guardar" class="float-right">
              </dx-button>
            </div>
          </div>
        </div>
      </div>
    </dx-popup>
  </div>
</div>